// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================

/**
 * Mt Forge — Runtime Copy Protection Module
 * Blocks devtools, right-click, text selection, and AI scraping vectors.
 */

const LEGAL_WARNING = `
%c============================================================
   STOP! THIS IS A PROTECTED APPLICATION.
============================================================

%cThis software is the proprietary property of
Mt Forge Inc. (Chestermere, AB).

Unauthorized access to, copying of, reverse engineering of,
or AI-assisted reproduction of this software or any of its
components is STRICTLY PROHIBITED and constitutes a violation
of US Copyright Law (17 U.S.C. § 501 et seq.), the Computer
Fraud and Abuse Act (18 U.S.C. § 1030), and applicable
international intellectual property treaties.

ALL activity is monitored and logged. Violators will be
prosecuted to the fullest extent of the law.

Patent Pending | Trade Secret Protected
Contact: r.miskulin@mtforge.ai
============================================================`;

const ASCII_LOGO = `
%c
███████╗████████╗ ██████╗ ██████╗
██╔════╝╚══██╔══╝██╔═══██╗██╔═══██╗
███████╗   ██║   ██║   ██║██████╔╝
╚════██║   ██║   ██║   ██║██╔═══╝
███████║   ██║   ╚██████╔╝██║
╚══════╝   ╚═╝    ╚═════╝ ╚═╝

  Mt Forge Inc.
  All Rights Reserved © 2026
  PROPRIETARY SOFTWARE
`;

/**
 * Block keyboard shortcuts that open devtools or view source.
 */
function blockDevtoolsKeys(e) {
  // F12
  if (e.key === 'F12' || e.keyCode === 123) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  // Ctrl+Shift+I  (DevTools)
  if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i' || e.keyCode === 73)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  // Ctrl+Shift+J  (Console)
  if (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j' || e.keyCode === 74)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  // Ctrl+U  (View Source)
  if (e.ctrlKey && (e.key === 'U' || e.key === 'u' || e.keyCode === 85)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  // Ctrl+Shift+C  (Inspect Element)
  if (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'c' || e.keyCode === 67)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  // Ctrl+S  (Save page)
  if (e.ctrlKey && !e.shiftKey && (e.key === 'S' || e.key === 's' || e.keyCode === 83)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
}

/**
 * Disable right-click context menu.
 */
function blockContextMenu(e) {
  e.preventDefault();
  return false;
}

/**
 * Detect devtools open state using timing / size differentials.
 */
function detectDevtools() {
  const threshold = 160;
  const widthDiff = window.outerWidth - window.innerWidth > threshold;
  const heightDiff = window.outerHeight - window.innerHeight > threshold;

  if (widthDiff || heightDiff) {
    document.title = '⚠️ PROTECTED APPLICATION — DevTools Detected';
  }
}

/**
 * Inject CSS that disables text selection everywhere except form inputs.
 */
function injectSelectionCSS() {
  const style = document.createElement('style');
  style.id = 'mt-copy-protection';
  style.textContent = `
    /* Mt Forge Copy Protection */
    body, body * {
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
    }
    input, textarea, [contenteditable="true"], select,
    input *, textarea *, [contenteditable="true"] * {
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      -ms-user-select: text !important;
      user-select: text !important;
    }
  `;
  document.head.appendChild(style);
}

/**
 * Print legal warnings and ASCII art to the console.
 */
function printConsoleWarnings() {
  console.log(
    LEGAL_WARNING,
    'color: #ff0000; font-size: 24px; font-weight: bold;',
    'color: #cc0000; font-size: 14px;'
  );
  console.log(
    ASCII_LOGO,
    'color: #1a73e8; font-size: 10px; font-family: monospace;'
  );
  console.log(
    '%cIf you are a developer or researcher and have found this console, ' +
    'note that all interactions are logged. Unauthorized use of information ' +
    'obtained from this application will be prosecuted.',
    'color: #666; font-size: 12px;'
  );
}

/**
 * Disable drag on images and links to prevent easy asset theft.
 */
function disableDrag() {
  document.addEventListener('dragstart', function(e) {
    e.preventDefault();
    return false;
  });
}

/**
 * Disable printing of the page.
 */
function blockPrint() {
  const style = document.createElement('style');
  style.textContent = '@media print { body { display: none !important; } }';
  document.head.appendChild(style);
}

/**
 * Initialize all copy protection measures.
 */
export function init() {
  if (typeof window === 'undefined') return;

  // Wait for DOM to be ready
  const setup = () => {
    document.addEventListener('keydown', blockDevtoolsKeys, true);
    document.addEventListener('contextmenu', blockContextMenu, true);
    injectSelectionCSS();
    printConsoleWarnings();
    disableDrag();
    blockPrint();

    // Check for devtools periodically
    setInterval(detectDevtools, 2000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
}

export default { init };
